var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link-band-list",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.routeToListFn($event)}}},[_vm._v(_vm._s(_vm.viewMoreTitle)+" 콘텐츠 모두보기")])}
var staticRenderFns = []

export { render, staticRenderFns }